export default __webpack_public_path__ + "static/media/hamburger_Icons-03.a856ddc5.png";